export default __webpack_public_path__ + "static/media/addFile.801d0623.PNG";